module.exports = __webpack_public_path__ + "static/turquia-006-4a25815df8494a174a365b7d51a51c6f.jpg";